var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgTooltipArrow = function SvgTooltipArrow(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M10.487 8.348a2 2 0 0 1-2.974 0L0 0h18l-7.513 8.348Z",
    fill: "currentColor"
  })));
};
export default SvgTooltipArrow;